import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const PaymentComplete = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const paymentError = queryParams.get('error');
  const paymentPrice = queryParams.get('price');
  const price = queryParams.get('price');
  const oid = queryParams.get('oid');
  const plan_id = queryParams.get('plan_id');
  const good_name = queryParams.get('good_name');

  const naver_script = () => {
    if (window.wcs) {
      if (!window.wcs_add) window.wcs_add = {};
      window.wcs_add['wa'] = 's_2489d344048e';
      var _conv: any = {};
      _conv.type = 'purchase'; //(필수)
      _conv.value = price; //(필수)
      _conv.id = oid;
      _conv.items = [
        {
          id: plan_id,
          name: good_name,
          payAmount: price,
        },
      ];
      window.wcs.trans(_conv);
    }
  };

  useEffect(() => {
    if (!paymentError) {
      naver_script();
    }
  }, [])
  
  return (
    <Container>
      <Helmet>
        <script type="text/javascript" src="//wcs.naver.net/wcslog.js"></script>
      </Helmet>
      <PageTop text={paymentError ? '결제 실패' : '결제 완료'} />
      {paymentError && <div>실패사유: {paymentError}</div>}
      <div style={{ alignItems: 'center' }}>
        <Button onClick={() => (window.location.href = '/')}>홈으로</Button>
      </div>
    </Container>
  );
};

export default PaymentComplete;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  overflow: hidden;
  position: relative;
`;

const Button = styled.button`
  color: white;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 16px;
  background-color: #008aff;
  cursor: pointer;

  &:hover {
    background-color: #1f98ff;
  }

  &:active {
    background-color: #45aaff;
  }
`;
